import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";

const CategoryList = Loadable(
  lazy(() =>
    import("./categoryTable").then(({ Category }) => ({
      default: Category,
    }))
  )
);

export const categoryRoutes = [
  {
    path: "/category",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.CUSTOMER]}>
        <CategoryList />
      </AuthorizedRoute>
    ),
  },
];
